/**
 * The schema form spans its host's scroll area edge to edge and spaces
 * itself: the tab bar covers the full width, every section keeps the gutter
 * at the sides, and the form pads its own top and bottom. Anything reaching
 * past the content (a unit's hover card, shadows) lands in the gutter instead
 * of being clipped by the scroll container.
 *
 * Hosts don't pad the form; they set the gutter on an ancestor (read by
 * `SectionTabs` and `ScopeSectionView` as `--schema-form-gutter`).
 */
export const SCHEMA_FORM_GUTTER = {
  /** Narrow panes: previews, the merge modal. */
  sm: '[--schema-form-gutter:calc(var(--spacing)*2)]',
  /** The resource pane. */
  md: '[--schema-form-gutter:calc(var(--spacing)*4)]',
  /** Dialogs, in line with their title's `px-6`. */
  lg: '[--schema-form-gutter:calc(var(--spacing)*6)]'
} as const;
